export const AUTH_ROUTES = {
  login: '/auth/login',
  verificationCode: '/auth/verification',
  recoveryCode: '/auth/recovery-code',
  logout: '/auth/logout',
};
